import React from 'react';
import { Link } from 'react-router-dom';
import Address from '../Formatting/Address';
import { getEntityLink, useNewWindow } from '../../Services/helpers';
import recents from './RecentsClass';
import { useSession } from '../../Components/Session';
import { useDialogues } from '../../Components/Dialogues';
import Icon from '../Icons/Icon';

const Result = ({children, to, close, model, id, external}) => {
    const handleClick = () => {
        if (model && id) {
            recents.add(model, id);
        }
        close();
    };

    if (external) {
        return <ExternalResult to={to} onClick={handleClick}>
            {children}
        </ExternalResult>;
    }

    return <Link to={to} onClick={handleClick} className="cursor-pointer hover:bg-slate-50 dark:hover:bg-black hover:ring ring-gray-200 dark:hover:ring-gray-700 rounded-lg p-2">
        {children}
    </Link>;
};

const ExternalResult = ({children, to, onClick}) => {
    const newWindow = useNewWindow();

    return <div onClick={() => {
        onClick();
        newWindow(to);
    }} className="cursor-pointer hover:bg-slate-50 dark:hover:bg-black hover:ring ring-gray-200 dark:hover:ring-gray-700 rounded-lg p-2">
        {children}
    </div>;
};

const CustomerResult = ({customer, close}) => {
    return <Result to={getEntityLink('Customers/Customer', customer.id)} close={close} model="Customers/Customer" id={customer.id}>
        <Address address={customer.address} limit={3} empty="[No address]" /><br />
        <div className="text-sm text-muted">{customer.name}</div>
    </Result>;
};

const RoundResult = ({round, close}) => {
    return <Result to={getEntityLink('Rounds/Round', round.id)} close={close} model="Rounds/Round" id={round.id}>
        {round.name}
    </Result>;
};

const QuoteResult = ({quote, close}) => {
    return <Result to={getEntityLink('Quotes/Quote', quote.id)} close={close} model="Quotes/Quote" id={quote.id}>
        <Address address={quote.address} limit={3} empty="[No address]" /><br />
        <div className="text-sm text-muted">{quote.name}</div>
    </Result>;
};

const PageResult = ({page, close}) => {
    const {hasFeature, isRoleSufficient} = useSession();
    const {featureUnavailable, roleInsufficient} = useDialogues();

    const featureLocked = page.feature && !hasFeature(page.feature);
    const roleLocked = page.role && !isRoleSufficient(page.role);
    const isLocked = featureLocked || roleLocked;

    if (isLocked) {
        return (
            <div
                onClick={() => {
                    if (featureLocked) {
                        featureUnavailable(page.feature);
                    } else if (roleLocked) {
                        roleInsufficient(page.role);
                    }
                    close();
                }}
                className="cursor-pointer hover:bg-slate-50 dark:hover:bg-black hover:ring ring-gray-200 dark:hover:ring-gray-700 rounded-lg p-2 flex items-center justify-between text-gray-400 dark:text-gray-500"
            >
                <div className="font-medium">{page.title}</div>
                <Icon icon="Lock" size="0.75x" className="fill-gray-400 dark:fill-gray-500" />
            </div>
        );
    }

    return <Result to={page.to} close={close} model="App/Page" id={page.to} external={page.external}>
        <div className="font-medium">{page.title}</div>
    </Result>;
};

const HelpDocResult = ({doc, close}) => {
    return <Result external={true} to={doc.link} close={close} id={doc.id}>
        <div className="font-medium">{doc.title}</div>
    </Result>;
};

export {
    CustomerResult,
    RoundResult,
    QuoteResult,
    PageResult,
    HelpDocResult,
};
